import { Colors } from "../../styles/theme";

const styles = {
  Accordion_container: {
    boxShadow: Colors.shadow,
    borderRadius: "15px",
    overflow: "hidden",
    marginBottom: "10px",
  },
  Accordion_faqContainer: {
    width: "100%",
    border: "1px solid #D7E1EF",
    borderRadius: "8px !important",
    backgroundColor: Colors.white,
    boxShadow: "none",
    overflow: "hidden",
    mb: 1.5,
    "&::before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: "0 0 12px",
      borderColor: Colors.primary,
      boxShadow: "0 8px 22px rgba(34, 49, 78, 0.05)",
    },
    "&:hover": {
      borderColor: "#8EA9CC",
    },
  },
  Accordion_faqSummary: {
    minHeight: { xs: 58, sm: 66 },
    px: { xs: 2, sm: 3 },
    "&.Mui-expanded": {
      minHeight: { xs: 58, sm: 66 },
    },
    "& .MuiAccordionSummary-content": {
      my: 1.5,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      my: 1.5,
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "none",
    },
  },
  Accordion_faqTitle: {
    color: Colors.navy,
    fontSize: { xs: "1.1rem", sm: "1.2rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.25,
  },
  Accordion_faqToggle: {
    width: { xs: 32, sm: 38 },
    height: { xs: 32, sm: 38 },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    borderRadius: "50%",
    backgroundColor: "#EAF1FA",
    color: Colors.primary,
    "& .MuiSvgIcon-root": {
      fontSize: { xs: 20, sm: 23 },
    },
  },
  Accordion_faqDetails: {
    px: { xs: 2, sm: 3 },
    pt: 0,
    pb: { xs: 2, sm: 2.5 },
  },
  Accordion_faqContent: {
    fontSize: { xs: "0.9rem", sm: "0.95rem" },
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: 1.5,
  },
};
export default styles;
